import { useMatchRoute } from '@tanstack/react-router';
import type { LinkProps } from '@tanstack/react-router';

/**
 * Czy ekran stoi na gołym adresie rekordu, czyli na menu zakładek.
 *
 * Szkielet ekranu pyta o to, żeby na menu nie doklejać panelu bocznego ani
 * belki podsumowania: na telefonie menu ma być samym nagłówkiem i wyborem,
 * a nie kolejnym długim ekranem, przez który trzeba przewinąć do kafli.
 */
export const useIsTabMenu = (
  menuLink: Pick<LinkProps, 'to' | 'params'>,
): boolean => {
  const matchRoute = useMatchRoute();

  return !!matchRoute({
    to: menuLink.to,
    params: menuLink.params,
    fuzzy: false,
  });
};
